import { MouseEventHandler } from 'react'
import styles from './styles.module.css'

interface PrimaryButtonProps {
	buttonName: string
	onClick: MouseEventHandler
	disabled?: boolean
	style?: React.CSSProperties
	children?: React.ReactNode
	cyLabel?: string // Add this new prop
}

export default function PrimaryButton({
	buttonName,
	disabled,
	onClick,
	style,
	children,
	cyLabel, // Add this parameter
}: PrimaryButtonProps) {
	

	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className={styles.primaryButton}
			style={style}
			data-cy={cyLabel} // Add this data attribute
		>
			<span className={styles.primaryButtonText}>
				{children || buttonName}
			</span>
		</button>
	)
}
